<template>
  <div>
    <div class="stepsdemo-content">
      <div class="card card-theme">
        <h3 class="card-title">
          Car Parks
        </h3>
        <h6 class="card-subtitle">
          Please add client's car parks
        </h6>
        <div class="p-grid p-nogutter p-justify-between">
          <Button label="Back" @click="prevPage()" icon="pi pi-angle-left"/>
          <Button v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'add_client', 'edit_client']))" label="Save & Next" @click="handleSubmit()" icon="pi pi-angle-right" iconPos="right"/>
          <Button v-else label="Next" @click="nextPage()" icon="pi pi-angle-right" iconPos="right"/>
        </div>
      </div>
    </div>

    <Panel class="capital"
           v-for="(carpark, index) of carparks"
           :header="'#' + (index + 1) + '. ' + (carpark.name ? carpark.name : 'Add carpark\'s info')"
           :key="carpark.code"
           :toggleable=true
           :collapsed=checkCollapsed()
           @toggle=resizeMaps()
    >
      <template #icons>
        <button v-if="carparks.length > 1 && (user_accesses && userService.hasAccess(user_accesses, ['admin', 'edit_client', 'add_client']))"
                class="p-panel-header-icon pi pi-trash"
                @click="carparkRemoveConfirm(carpark.code)">
        </button>
      </template>
      <div class="p-grid nested-grid">

        <div class="p-col-12 p-lg-5">
          <h3 class="card-title">
            Car Park Info
          </h3>

          <div class="p-grid">
            <div v-if="carpark.mode == 'edit'" class="p-col-12">
              <div class="form-group">
                <label for="code">Code</label>
                <InputText disabled type="text" v-model="carpark.code" class="form-control"/>
              </div>
            </div>

            <div class="p-col-12">
              <div class="form-group">
                <label for="name">Name</label>
                <InputText type="text" v-model="carpark.name" class="form-control" :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].name.$error }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].name.required" class="invalid-feedback">Name is required</div>
              </div>
            </div>

            <div class="p-col-12">
                <span class="form-group">
                  <label for="charity">Charity</label>
                  <Dropdown class="form-control"
                            id="charity"
                            v-model="carpark.charity"
                            :options="charity_list"
                            optionLabel="name"
                            :filter="true"
                            placeholder="Select a Charity"
                            :showClear="true"
                            :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].charity.$error }">
                      <template #value="slotProps">
                          <div class="charity-item" v-if="slotProps.value">
                              <img :src="slotProps.value.images ? '/assets/layout/images/charities/' + slotProps.value.images[0] : '/assets/layout/images/charities/default.jpg'"/>
                              <div>{{slotProps.value.name}}</div>
                          </div>
                          <span v-else>
                              {{slotProps.placeholder}}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <div class="charity-item">
                             <img :src="slotProps.option.images ? '/assets/layout/images/charities/' + slotProps.option.images[0] : '/assets/layout/images/charities/default.jpg'"/>
                             <div>{{slotProps.option.name}}</div>
                          </div>
                      </template>
                  </Dropdown>
                  <div v-if="submitted && !$v.carparks.$each.$iter[index].charity.required" class="invalid-feedback">Charity is required</div>
                </span>
            </div>

            <div class="p-col-12" v-if="user_accesses && userService.hasAccess(user_accesses, ['admin'])">
              <div class="form-group">
                <label for="name">Management Fee</label>
                <InputText type="text" v-model="carpark.management_fee" class="form-control" :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].management_fee.$error }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].management_fee.required" class="invalid-feedback">Management fee is required</div>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].management_fee.decimal" class="invalid-feedback">Management fee should be decimal</div>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].management_fee.between" class="invalid-feedback">Management fee should be between {{$v.carparks.$each.$iter[index].management_fee.$params.between.min}} and {{$v.carparks.$each.$iter[index].management_fee.$params.between.max}}</div>

              </div>
            </div>

            <div class="p-col-12">
                <span class="p-field">
                  <label for="description">Description</label>
                  <Textarea id="description" class="card-input" :autoResize="true" rows="5" cols="30"
                            v-model="carpark.description"/>
                </span>
            </div>
            <div class="p-col-12">
              <label>Images</label>
              <image-uploader
                      :images="carpark.images"
                      :code="carpark.code"
                      @new-image="onNewImage"
                      @edit-image="onEditImage"
                      @remove-image="onRemoveImage"
              ></image-uploader>
            </div>
          </div>

        </div>

        <div class="p-col-12 p-lg-1"></div>

        <div class="p-col-12 p-lg-5">
          <h3 class="card-title">
            Location Info
          </h3>

          <div class="p-grid">

            <!-- <div class="p-col-12">
                  <span class="p-field">
                    <label for="region">Region</label>
                    <Dropdown class="card-input" id="region" v-model="carpark.region" :options="region_list"
                              optionLabel="name" :filter="true"
                              placeholder="Select a Region" :showClear="true">
                      <template #value="slotProps">
                          <div class="charity-item" v-if="slotProps.value">
                              <div>{{slotProps.value.name}}</div>
                          </div>
                          <span v-else>
                              {{slotProps.placeholder}}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <div class="charity-item">
                              <div>{{slotProps.option.value}}</div>
                          </div>
                      </template>
                    </Dropdown>
                  </span>
            </div> -->

            <!-- <div class="p-col-12">
                <span class="form-group">
                  <label for="city">City</label>
                  <Dropdown class="form-control"
                            v-model="carpark.city" 
                            :options="city_list"
                            @change="onCitySelected(carpark)"
                            optionLabel="name" 
                            :filter="true"
                            placeholder="Select a City" 
                            :showClear="true"
                            :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].city.$error }">
                      <template #value="slotProps">
                          <div class="charity-item" v-if="slotProps.value">
                              <div>{{slotProps.value.name}}</div>
                          </div>
                          <span v-else>
                              {{slotProps.placeholder}}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <div class="charity-item">
                              <div>{{slotProps.option.name}}</div>
                          </div>
                      </template>
                  </Dropdown>
                  <div v-if="submitted && !$v.carparks.$each.$iter[index].city.required" class="invalid-feedback">City is required</div>

                </span>
            </div> -->

            <div class="p-col-12">
              <span class="p-field">
                <my-map
                        :position="carpark.position"
                        :center="carpark.center"
                        :zoom="carpark.zoom"
                        :code="carpark.code"
                        @position-change="onPositionChange"
                        @zoom-change="onZoomChange"
                        @center-change="onCenterChange"
                        @map-init="onMapInit"
                ></my-map>
              </span>
            </div>
            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label for="latitude">Latitude</label>
                <InputText type="text" v-model="carpark.position.lat" class="form-control" :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].position.lat.$error }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].position.lat.required" class="invalid-feedback">Latitude is required</div>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].position.lat.decimal" class="invalid-feedback">Latitude should be decimal</div>
              </div>
            </div>
            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label for="longitude">Longitude</label>
                <InputText type="text" v-model="carpark.position.lng" class="form-control" :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].position.lng.$error }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].position.lng.required" class="invalid-feedback">Longitude is required</div>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].position.lng.decimal" class="invalid-feedback">Longitude should be decimal</div>
              </div>
            </div>

            <div class="p-col-12 p-md-12 p-lg-12">
              <label>Address</label>
              <hr/>
            </div>
            
            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label>Address 1</label>
                <InputText  type="text" 
                            v-model="carpark.address_obj.street_1" 
                            class="form-control" 
                            :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].address_obj.street_1.$error }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].address_obj.street_1.required" class="invalid-feedback">Address 1 is required</div>
              </div>
            </div>

            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label>Address 2 (Optional)</label>
                <InputText type="text" v-model="carpark.address_obj.street_2" class="form-control" />
              </div>
            </div>

            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label>City</label>
                <InputText style="text-transform: capitalize" type="text" v-model="carpark.address_obj.city" class="form-control" :class="{ 'is-invalid': submitted &&  $v.carparks.$each.$iter[index].address_obj.city.$error  }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].address_obj.city.required" class="invalid-feedback">City is required</div>
              </div>
            </div>

            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label>County (Optional)</label>
                <InputText type="text" v-model="carpark.address_obj.county" class="form-control"/>
              </div>
            </div>

            <div class="p-col-6 p-lg-6">
              <div class="form-group">
                <label>Postal Code</label>
                <InputText type="text" v-model="carpark.address_obj.postal_code" class="form-control" :class="{ 'is-invalid': submitted && $v.carparks.$each.$iter[index].address_obj.postal_code.$error }"/>
                <div v-if="submitted && !$v.carparks.$each.$iter[index].address_obj.postal_code.required" class="invalid-feedback">Postal code is required</div>
              </div>
            </div>

            <div class="p-col-12 p-md-12 p-lg-12">
              <hr/>
            </div>


          </div>

        </div>

      </div>
    </Panel>

    <br>

    <Button icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="newCarpark()"
            v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'add_client'])"
    />

    <Dialog :visible.sync="deleteCarparkDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
        <span v-if="carpark.name">Do you want to remove {{carpark.name}}?</span>
        <span v-else>Do you want to remove this Car Park?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteCarparkDialog = false"/>
        <Button label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="removeCarpark"
        />
      </template>
    </Dialog>

  </div>

</template>

<script>
  import MyMap from '../LMap'
  import ImageUploader from "../ImageUploader";
  // import CityService from '../../services/CityService';
  import CharityService from "../../services/CharityService";
  import UserService from '../../services/UserService';
  import { required, decimal, between } from 'vuelidate/lib/validators'

  export default {
    components: {ImageUploader, MyMap},
    data() {
      return {
        carparks: [],
        carpark: {},
        // city_list: [],
        map_obj_lists: [],
        region_list: [
          {name: "North", value: 'north'},
          {name: "South", value: 'south'},
          {name: "West", value: 'west'},
          {name: "East", value: 'east'},
          {name: "Center", value: 'center'},
        ],
        charity_list: [],
        deleteCarparkDialog: false,
        deleteImageDialog: false,
        user_accesses: this.$store.state.accesses,
        userService: null,
        // cityService: null,
        submitted: false
      }
    },
    validations: {
      carparks: {
        $each: {
          name: {
            required
          },
          management_fee: {
            required,
            decimal,
            between: between(0, 100)
          },
          address_obj: {
            street_1: {
              required
            },
            city: {
              required
            },
            postal_code: {
              required
            }
          },
          charity: {
            required
          },
          // city: {
          //   required
          // },
          position: {
            lat: {
              required,
              decimal
            },
            lng: {
              required,
              decimal
            }
          }
        }
      },
    },
    methods: {
      nextPage() {
        this.submitted = true;
        this.$emit('nextPage', {
          pageIndex: 1
        });
      },
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Validation failed!',
            detail: 'You can proceed after all marked fields are rectified',
            life: 5000
          });
          return;
        }

        this.$emit('complete', {
          formData: {
            carparks: this.carparks,
            step: 'carpark_info'
          },
          pageIndex: 1
        });
      },
      prevPage() {
        this.$emit('prevPage', {pageIndex: 1});
      },
      checkCollapsed() {
        return (this.carparks && this.carparks[0].id !== '')
      },
      carparkRemoveConfirm(code) {
        let index = this.carparks.findIndex(item => item.code === code);
        this.carpark = this.carparks[index];
        this.deleteCarparkDialog = true;
      },
      removeCarpark() {
        this.carparks = this.carparks.filter(item => item.code !== this.carpark.code);
        this.carpark = {};
        this.deleteCarparkDialog = false;
      },
      onPositionChange(position, code) {
        let index = this.carparks.findIndex(item => item.code === code);
        this.carparks[index].position = position
      },
      onZoomChange(zoom, code) {        
        let index = this.carparks.findIndex(item => item.code === code);
        this.carparks[index].zoom = zoom
      },
      onCenterChange(center, code) {
        let index = this.carparks.findIndex(item => item.code === code);
        this.carparks[index].center = center
      },
      onMapInit(mapObj) {
        this.map_obj_lists.push(mapObj)
      },
      newCarpark(carpark) {
        this.carparks.push(
            {
              id: carpark ? carpark.id : '',
              code: carpark ? carpark.code : this.uniqueID(),
              name: carpark ? carpark.name : '',
              region: carpark ? carpark.region : '',
              // city: carpark ? carpark.city : '',
              address_obj: carpark ? carpark.address_obj : {street_1: "", street_2: "", city: "", postal_code: "", county: ""},
              charity: carpark ? carpark.charity : '',
              management_fee: carpark ? carpark.management_fee * 100 : '',
              description: carpark ? carpark.description : '',
              images: carpark ? carpark.images : [],
              image: {},
              position: carpark ? carpark.position : {lat: "51.483427", lng: "-0.1295185"},
              zoom: carpark ? carpark.zoom : 6,
              center: carpark ? carpark.center : {lat: "51.483427", lng: "-0.1295185"},
              mode: carpark ? 'edit' : 'new'
            }
        );
      },
      uniqueID() {
        return Math.random().toString(36).slice(2).substr(0, 4).toUpperCase();
      },
      onNewImage(code, image) {
        let index = this.carparks.findIndex(item => item.code === code);
        this.carparks[index].images.push(image)
      },
      onEditImage(code, img_index, fileList) {
        let index = this.carparks.findIndex(item => item.code === code);
        this.carparks[index].images[img_index] = fileList[img_index]
      },
      onRemoveImage(code, img_index) {
        let index = this.carparks.findIndex(item => item.code === code);
        this.carparks[index].images.splice(img_index, 1);
      },
      // onCitySelected(carpark) {
      //   let carpark_index = this.carparks.findIndex(item => item.code === carpark.code);
      //   let city_index = this.city_list.findIndex(item => item.name.toLowerCase() === carpark.city.name.toLowerCase());
      //   this.carparks[carpark_index].position = this.city_list[city_index].position
      //   this.carparks[carpark_index].address_obj.city = carpark.city.name
      // },
      // setCities() {
      //   this.cityService.cities().then((cities) => {
      //     this.city_list = cities;
      //   });
      // },
      setCharities() {
        this.charityService.listCharities().then((data) => {
          this.charity_list = data.data.charities;
        });
      },
      resizeMaps() {
        this.map_obj_lists.map(mapObj => mapObj._onResize())
      }
    },
    created() {
      // this.cityService = new CityService();
      this.charityService = new CharityService();
      this.userService = new UserService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      // this.setCities();
      this.setCharities();
      let client_info = localStorage.getItem("client_info") ? JSON.parse(localStorage.getItem("client_info")) : null;
      if (client_info && client_info.carparks && client_info.carparks.length > 0) {
        client_info.carparks.map(carpark => this.newCarpark(carpark));
      } else {
        this.newCarpark();
      }
    }
  }

</script>

<style lang="scss" scoped>
  .card-subtitle {
    margin: 0;
    margin-bottom: 3em;
  }

  .card-title {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .card-input {
    width: 100%;
    margin-bottom: 1rem;
  }

  .charity-item {
    display: flex;
    text-transform: capitalize;

    img {
      width: 20px;
      margin-right: 10px;
    }
  }

  .capital {
    text-transform: capitalize;
  }
</style>